import { TimelineItem as Item } from './item';
import { Timeline as TimelineComponent } from './timeline';
export var Timeline = Object.assign(TimelineComponent, {
  Item: Item
});